/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Delete_Account_ButtonInputs */

const en_settings_delete_account_button = /** @type {(inputs: Settings_Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permanently Delete Account`)
};

const de_settings_delete_account_button = /** @type {(inputs: Settings_Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto endgueltig loeschen`)
};

const fr_settings_delete_account_button = /** @type {(inputs: Settings_Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer definitivement le compte`)
};

const es_settings_delete_account_button = /** @type {(inputs: Settings_Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar cuenta permanentemente`)
};

const it_settings_delete_account_button = /** @type {(inputs: Settings_Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina account in modo permanente`)
};

const nl_settings_delete_account_button = /** @type {(inputs: Settings_Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account permanent verwijderen`)
};

const pl_settings_delete_account_button = /** @type {(inputs: Settings_Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trwale usun konto`)
};

const fi_settings_delete_account_button = /** @type {(inputs: Settings_Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poista tili pysyvästi`)
};

const da_settings_delete_account_button = /** @type {(inputs: Settings_Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slet konto permanent`)
};

const sv_settings_delete_account_button = /** @type {(inputs: Settings_Delete_Account_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ta bort konto permanent`)
};

/**
* | output |
* | --- |
* | "Permanently Delete Account" |
*
* @param {Settings_Delete_Account_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_delete_account_button = /** @type {((inputs?: Settings_Delete_Account_ButtonInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Delete_Account_ButtonInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_delete_account_button(inputs)
	if (locale === "fr") return fr_settings_delete_account_button(inputs)
	if (locale === "es") return es_settings_delete_account_button(inputs)
	if (locale === "it") return it_settings_delete_account_button(inputs)
	if (locale === "nl") return nl_settings_delete_account_button(inputs)
	if (locale === "pl") return pl_settings_delete_account_button(inputs)
	if (locale === "fi") return fi_settings_delete_account_button(inputs)
	if (locale === "da") return da_settings_delete_account_button(inputs)
	if (locale === "sv") return sv_settings_delete_account_button(inputs)
	return en_settings_delete_account_button(inputs)
});